import React from 'react';
import { FieldsCardProps } from 'types/DetailPageTypes'; 
import { useTranslation } from 'react-i18next';
import '../../style/scss/card.scss';

const TabsCard: React.FC<FieldsCardProps> = ({ 
    viewKey, apiObject, itemId, title, data, dropdownData, groupOptions, alignment, loadStatus, refetchData 
}) => {
    const { t } = useTranslation();

    return (
        <div className='card materialscard'>
            {loadStatus === "loading" ? (
                <div className="loader"></div>
            ) : loadStatus === "loaded" && (
                <p>Tabs here</p>
            )}
        </div>
    );
}

export default TabsCard;